import * as React from 'react'
import {
  Pressable,
  PressableProps,
  StyleProp,
  StyleSheet,
  Text,
  View,
  ViewStyle,
} from 'react-native'
import { neutralGray, actionBlue } from '@themes/Colors'

type BaseProps = {
  buttonStyle?: StyleProp<ViewStyle>
  children: string | React.ReactNode
}

type Props = BaseProps & PressableProps

export function MiniButton({ buttonStyle, ...props }: Props) {
  return (
    <Pressable {...props}>
      {({ pressed }) => (
        <View
          style={[styles.button, pressed && styles.buttonPressed, buttonStyle]}
        >
          {typeof props.children === 'string' ? (
            <Text style={styles.text}>{props.children}</Text>
          ) : (
            <>{props.children}</>
          )}
        </View>
      )}
    </Pressable>
  )
}

export const styles = StyleSheet.create({
  button: {
    backgroundColor: neutralGray,
    borderRadius: 8,
    paddingVertical: 8,
    paddingHorizontal: 32,
  },
  buttonPressed: {
    opacity: 0.2,
  },
  text: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '500',
    color: actionBlue,
  },
})
